/** @jsxImportSource @emotion/react */
import { EuiPageTemplate } from "@inscopix/ideas-eui";
import { PanelProjects } from "components/PanelProjects/PanelProjects";
import { PanelWelcome } from "components/PanelWelcome/PanelWelcome";
import { PageDashboardSideBar } from "pages/dashboard/PageDashboard/PageDashboardSidebar";
import { useUserContext } from "providers/UserProvider/UserProvider";
import { useSetCurrentPage } from "providers/TourProvider/TourProvider.hooks";
import { Helmet } from "react-helmet-async";
import { DemoProjects } from "components/DemoProjects/DemoProjects";
import { isDefined } from "utils/isDefined";
import { css } from "@emotion/react";
import { ideasFeatures } from "ideas.features";
import { useRef } from "react";
import { HeaderDashboard } from "components/HeaderDashboard/HeaderDashboard";

export const PageHome = () => {
  useSetCurrentPage("home");
  const { hasTenants, hasPersonalSpace } = useUserContext((s) => ({
    hasTenants: s.tenants.length > 0 || s.externalTenants.length > 0,
    hasPersonalSpace: isDefined(s.personalSpace),
  }));

  const virtuaScrollRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <Helmet>
        <title>{`Dashboard`}</title>
      </Helmet>
      <EuiPageTemplate
        panelled={true}
        bottomBorder={"extended"}
        responsive={["xs"]}
        mainProps={{
          css: css`
            overflow: auto;
            max-block-size: calc(100vh - var(--euiFixedHeadersOffset, 0));
          `,
        }}
      >
        <EuiPageTemplate.Sidebar minWidth={300} sticky={true}>
          <PageDashboardSideBar />
        </EuiPageTemplate.Sidebar>

        <HeaderDashboard tenantId={undefined} />

        <div
          style={{
            width: "100%",
            height: "100%",
            overflowY: "auto",
            // opt out browser's scroll anchoring on header/footer because it will conflict to scroll anchoring of virtualizer
            overflowAnchor: "none",
          }}
          ref={virtuaScrollRef}
        >
          <PanelProjects virtuaScrollRef={virtuaScrollRef} />

          {ideasFeatures.personalSpace && !hasTenants && !hasPersonalSpace && (
            <PanelWelcome />
          )}
          {ideasFeatures.demoProjects && !hasTenants && <DemoProjects />}
        </div>
      </EuiPageTemplate>
    </>
  );
};
